import { useQuery } from '@tanstack/react-query';
import { getShareConfig } from '@/api/subtitles';

// ShareConfigResp 在 types.d.ts 的 ambient `declare namespace API` 里,
// 全局可用,不需要显式 import。

export interface UseShareConfigResult {
  desktopLangs: string[];
  /** 主播预选的观众可选语言全集(含桌面端语言)。旧后端未返回时回落为 desktopLangs */
  allowedLangs: string[];
  /** 自由模式: 观众可从全部语言里选(合计仍 ≤4, 互相挤占)。false = 只能在 allowedLangs 内选 */
  audienceFreeChoice: boolean;
  audienceLangs: string[];
  isLoading: boolean;
  refetch: () => void;
}

export function useShareConfig(roomId?: string): UseShareConfigResult {
  const { data, isLoading, refetch } = useQuery<API.ShareConfigResp>({
    queryKey: ['shareConfig', roomId],
    queryFn: async () => {
      const res = await getShareConfig({ roomId: roomId! });
      // res 是 axios response, 实际数据在 res.data.data
      return res.data.data;
    },
    enabled: !!roomId,
    // 5 秒一次 —— 主播在分享弹窗增减 allowed_langs / 改 desktop_langs 时观众侧近实时同步
    refetchInterval: 5_000,
    staleTime: 2_000,
  });

  const desktopLangs = data?.desktop_langs ?? [];
  return {
    // 内部用 camelCase 返回(hook 是给 React 组件用的,组件侧约定 camelCase)
    desktopLangs,
    allowedLangs: data?.allowed_langs?.length ? data.allowed_langs : desktopLangs,
    audienceFreeChoice: data?.audience_free_choice === true,
    audienceLangs: data?.audience_langs ?? [],
    isLoading,
    refetch,
  };
}
